import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastManagerProp, withToastManager } from 'react-toast-notifications';

import { LoaderSpinner } from 'components/UtilElements';
import * as dt from 'core/datetime';
import { apiErrorHandler } from 'core/errors';
import { DATE_FORMAT } from 'globals/constants';
import { Dispatch } from 'redux';
import { UPDATE_STUDENT_ACCOUNTS } from 'redux/actions';
import { API, getCancelToken, request } from 'redux/api';
import { RootState } from 'redux/reducers';
import { pluralize } from 'utils';

interface GetStudentAccountsResponse {
  message: string;
  users: SignedUpUser[];
}

interface StudentAccountProps extends ToastManagerProp {
  studentAccounts: SignedUpUser[];
  updateStudentAccounts(students: SignedUpUser[]): Promise<void>;
}

interface StudentAccountState {
  loading: boolean;
}

class StudentAccount extends Component<StudentAccountProps, StudentAccountState> {
  apiSources = getCancelToken();

  state: StudentAccountState = {
    loading: true,
  };

  async getStudentAccounts() {
    const response = await request<GetStudentAccountsResponse>({
      url: API.SIGNED_UP_STUDENTS,
      cancelToken: this.apiSources.token,
    });
    return response.users;
  }

  async componentDidMount() {
    this.apiSources = getCancelToken();
    try {
      const accounts = await this.getStudentAccounts();
      this.props.updateStudentAccounts(accounts);
      this.setState({ loading: false });
    } catch (err) {
      apiErrorHandler(this.props.toastManager, err, () => {
        this.setState({ loading: false });
      });
    }
  }

  componentWillUnmount() {
    this.apiSources.cancel();
  }

  getTable = () => {
    const { loading } = this.state;

    if (loading) {
      return (
        <div className='loader-wrapper'>
          <LoaderSpinner />
        </div>
      );
    }

    return (
      <table className='table table--bordered'>
        <tbody>
          {this.props.studentAccounts.map((account) => (
            <tr key={account.userId}>
              <td className='table__cell'>
                <div className='table__cell-header table__cell-header--title'>{account.name}</div>
                <div className='table__cell-value'>
                  <a
                    className='link primary'
                    href={`mailto:${account.emailId}`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {account.emailId}
                  </a>
                </div>
              </td>
              <td className='table__cell'>
                <div className='table__cell-header'>JOINED ON</div>
                <div className='table__cell-value table__cell-value--no-wrap'>
                  {account.joinedOn > 0 ? dt.format(account.joinedOn, DATE_FORMAT) : '--'}
                </div>
              </td>
              <td className='table__cell'>
                <div className='table__cell-header'>COURSES ON ACADLY</div>
                <div className='table__cell-value'>{account.courses.length}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  render() {
    const { loading } = this.state;
    const { studentAccounts } = this.props;

    return (
      <div className='section'>
        <div className='section__header'>
          <h3 className='section__title'>
            {loading
              ? 'Loading student accounts...'
              : studentAccounts.length
              ? `${studentAccounts.length} student ${pluralize(studentAccounts.length, 'account')} on Acadly`
              : 'No students have signed up for Acadly yet'}
          </h3>
        </div>
        <div className='section__body'>{this.getTable()}</div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  studentAccounts: state.studentAccounts,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateStudentAccounts: async (data: SignedUpUser[]) => {
    dispatch({
      type: UPDATE_STUDENT_ACCOUNTS,
      payload: data,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(StudentAccount));
